import isValidIBAN from "../validations/is.valid.iban";

export default (values, value, type) => isValidIBAN(value);
